import React from 'react';
import { ChevronRightIcon, FilterIcon, PhoneIcon } from 'lucide-react';
import { ProductCard } from '../components/shared/ProductCard';
interface ProductListingPageProps {
  onNavigate: (page: 'product') => void;
}
export function ProductListingPage({
  onNavigate
}: ProductListingPageProps) {
  const products = [{
    name: 'Royal Canin Medium Adult Dry Dog Food 15kg',
    price: 109.99,
    category: 'Dog Food',
    badge: 'Best Seller',
    badgeType: 'blue' as const,
    memberPrice: 99.99,
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Black Hawk Grain Free Chicken Adult Dog Food 15kg',
    price: 119.99,
    category: 'Dog Food',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Kong Classic Dog Toy Large',
    price: 29.99,
    category: 'Dog Toys',
    badge: 'Popular',
    badgeType: 'green' as const,
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Hills Science Diet Puppy Large Breed 12kg',
    price: 94.99,
    category: 'Dog Food',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Advocate Flea & Worming for Large Dogs 3 Pack',
    price: 65.99,
    category: 'Dog Health',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Snooza Ortho Snuggler Bed Large',
    price: 149.99,
    category: 'Dog Beds',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Pro Plan Adult Sensitive Skin & Stomach 12kg',
    price: 114.99,
    category: 'Dog Food',
    memberPrice: 104.99,
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Greenies Dental Treats Regular 340g',
    price: 34.99,
    category: 'Dog Treats',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }];
  return <main className="bg-warm-50 min-h-screen pb-20" data-id="element-791">
      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100 py-4" data-id="element-792">
        <div className="container-wide flex items-center text-sm text-gray-500" data-id="element-793">
          <span className="hover:text-brand-blue cursor-pointer" data-id="element-794">Home</span>
          <ChevronRightIcon className="w-4 h-4 mx-2" data-id="element-795" />
          <span className="font-medium text-gray-900" data-id="element-796">Dogs & Puppies</span>
        </div>
      </div>

      <div className="container-wide pt-8" data-id="element-797">
        <div className="flex flex-col md:flex-row gap-8" data-id="element-798">
          {/* Sidebar Filters (Desktop) */}
          <aside className="hidden md:block w-64 flex-shrink-0" data-id="element-799">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sticky top-24" data-id="element-800">
              <div className="flex items-center justify-between mb-6" data-id="element-801">
                <h3 className="font-heading font-bold text-lg text-gray-900 flex items-center gap-2" data-id="element-802">
                  <FilterIcon className="w-5 h-5" data-id="element-803" /> Filters
                </h3>
                <button className="text-sm text-brand-blue hover:underline" data-id="element-804">
                  Clear All
                </button>
              </div>

              {/* Category Filter */}
              <div className="mb-6" data-id="element-805">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-806">Category</h4>
                <div className="space-y-2" data-id="element-807">
                  {['Dog Food', 'Dog Treats', 'Dog Health', 'Dog Toys', 'Dog Beds', 'Dog Accessories'].map((cat, i) => <label key={i} className="flex items-center gap-3 cursor-pointer group" data-id="element-808">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-brand-blue transition-colors" data-id="element-809">
                        {i === 0 && <div className="w-3 h-3 bg-brand-blue rounded-sm" data-id="element-810"></div>}
                      </div>
                      <span className="text-gray-700 group-hover:text-gray-900" data-id="element-811">
                        {cat}
                      </span>
                    </label>)}
                </div>
              </div>

              {/* Brand Filter */}
              <div className="mb-6" data-id="element-812">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-813">Brand</h4>
                <div className="space-y-2" data-id="element-814">
                  {['Royal Canin', 'Black Hawk', 'Pro Plan', 'Hills Science Diet', 'Kong'].map((brand, i) => <label key={i} className="flex items-center gap-3 cursor-pointer group" data-id="element-815">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-brand-blue transition-colors" data-id="element-816"></div>
                      <span className="text-gray-700 group-hover:text-gray-900" data-id="element-817">
                        {brand}
                      </span>
                    </label>)}
                </div>
              </div>

              {/* Price Range (Visual only) */}
              <div data-id="element-818">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-819">
                  Price Range
                </h4>
                <div className="w-full h-2 bg-gray-200 rounded-full mb-4 relative" data-id="element-820">
                  <div className="absolute left-1/4 right-1/4 h-full bg-brand-blue rounded-full" data-id="element-821"></div>
                  <div className="absolute left-1/4 top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-2 border-brand-blue rounded-full shadow-sm" data-id="element-822"></div>
                  <div className="absolute right-1/4 top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-2 border-brand-blue rounded-full shadow-sm" data-id="element-823"></div>
                </div>
                <div className="flex justify-between text-sm text-gray-500" data-id="element-824">
                  <span data-id="element-825">$0</span>
                  <span data-id="element-826">$200+</span>
                </div>
              </div>
            </div>
          </aside>

          {/* Main Content */}
          <div className="flex-1" data-id="element-827">
            {/* Header */}
            <div className="mb-8" data-id="element-828">
              <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-829">
                Dogs & Puppies
              </h1>
              <p className="text-gray-600 max-w-3xl" data-id="element-830">
                Everything your best mate needs, from premium nutrition and
                tasty treats to comfortable beds and engaging toys. Expert
                advice available in-store.
              </p>
            </div>

            {/* Mobile Filter Button & Sort */}
            <div className="flex items-center justify-between mb-6 bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-831">
              <button className="md:hidden flex items-center gap-2 font-medium text-gray-700" data-id="element-832">
                <FilterIcon className="w-5 h-5" data-id="element-833" /> Filters
              </button>

              <div className="flex items-center gap-3 ml-auto" data-id="element-834">
                <span className="text-sm text-gray-500 hidden sm:inline" data-id="element-835">
                  Sort by:
                </span>
                <select className="bg-warm-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-brand-blue focus:border-brand-blue block p-2.5 font-medium" data-id="element-836">
                  <option data-id="element-837">Featured</option>
                  <option data-id="element-838">Price: Low to High</option>
                  <option data-id="element-839">Price: High to Low</option>
                  <option data-id="element-840">Newest Arrivals</option>
                </select>
              </div>
            </div>

            {/* Product Grid */}
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-10" data-id="element-841">
              {products.map((product, index) => <ProductCard key={index} {...product} onNavigate={onNavigate} data-id="element-842" />)}
            </div>

            {/* Pagination / Load More */}
            <div className="flex justify-center mb-12" data-id="element-843">
              <button className="btn-secondary bg-white shadow-sm" data-id="element-844">
                Load More Products
              </button>
            </div>

            {/* Help Banner */}
            <div className="bg-brand-blue-50 rounded-2xl p-8 text-center border border-brand-blue-100" data-id="element-845">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm" data-id="element-846">
                <PhoneIcon className="w-8 h-8 text-brand-blue" data-id="element-847" />
              </div>
              <h3 className="font-heading font-bold text-2xl text-gray-900 mb-2" data-id="element-848">
                Can't find what you're looking for?
              </h3>
              <p className="text-gray-600 mb-6 max-w-lg mx-auto" data-id="element-849">
                Our stores carry thousands of products not listed online. Call
                your local store and our team will help you find exactly what
                you need.
              </p>
              <button className="btn-primary shadow-soft" data-id="element-850">
                Contact Your Local Store
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>;
}